export const SETUP_PASSWORD_TYPE = 'setup'
export const CHANGE_PASSWORD_TYPE = 'change'
